module.exports = __webpack_public_path__ + "img/naslag.af347fdd.png";